<breadcrumb
  [paginas]="[
    { route: '/home', name: 'Home' },
    { route: '/consulta-ponto', name: 'Registrar saída da escola' }
  ]"
/>
<section class="section-filtro">
  <!-- <app-filtro-padrao
    (filtroEmitter)="searchHandler($event)"
    [template]="2"
    [style]="1"
  ></app-filtro-padrao> -->
</section>
<!-- TITULO -->
<section class="section-saudacao">
  <div class="container">
    <h2 class="titulo-page">Registrar saída da escola</h2>
    <app-btn-back class="btn_voltar_consulta"></app-btn-back>
  </div>
  <div class="container boas-vindas">
    <p>
      "Olá, <b>{{ this.userLogado?.nome }}!</b> 👋
    </p>
  </div>
</section>

<section class="section-data-regitro-saida">
  <form [formGroup]="formInserir">
    <div class="container">
      <div class="conteudo-data-check-in-out">
        <input
          type="date"
          class="input-date"
          formControlName="dataSaida"
          [min]="minDate | date : 'yyyy-MM-dd'"
          [max]="maxDate | date : 'yyyy-MM-dd'"
          placeholder="Data da Saída"
          aria-label="Data da Saída"
        />
        <div class="horarios">
          <div class="conteudo-check">
            <p>
              Hora Check in: <b> {{ dataInicio | date : "HH:mm" }} </b>
            </p>
            <p>
              Hora Check-Out: <b>{{ dataFim | date : "HH:mm" }}</b>
            </p>
            @if(jornadaNaoFinalizada?.dataInicio && jornadaNaoFinalizada?.dataFim)
            {
            <p class="horas-trabalhadas">
              Total de horas trabalhadas:<b>{{
                totalHorasTrabalhadas | date : "HH:mm"
              }}</b>
            </p>

            }
          </div>
          <!-- <div class="small-hour">
            <small > Tempo Deslocamento: {{calculaTempoDeslocamento() | date : "HH:mm"}} + Tempo de Registro: {{totalHorasTempoRegistro | date : "HH:mm"}} + Horario Check-Out {{jornadaNaoFinalizada?.dataFim| date : "HH:mm"}}  = {{this.HorariocheckOut | date : "HH:mm"}} </small>
          </div> -->
        </div>
      </div>
      <!-- <button
        class="btn-registar-saida"
        [disabled]="
          !this.jornadaNaoFinalizada?.dataInicio ||
          this.jornadaNaoFinalizada?.dataFim
        "
        (click)="abrirModalFinalizarJornada()"
      >
        Registrar Saída
      </button> -->
    </div>
  </form>
</section>

<section class="section-grid-consulta-ponto">
  <div class="container">
    <div class="row_registros">
      <h3>Registro de Entrada e Saída</h3>
      <div class="conteudo-btn-grid">
        <button
          *ngIf="exibirBotaoAdicionarAtividade()"
          type="button"
          class="btn_adicionar_registro btn_adicionar_atividade"
          title="Adicionar Atividade"
          (click)="redirectToAddAtividade()"
        >
          <i aria-hidden="true" class="fa fa-plus"></i>
          <span>Adicionar Atividade</span>
        </button>
        <!-- <button
          class="btn_outline"
          [disabled]="
            !(jornadaNaoFinalizada?.dataFim || jornadaNaoFinalizada?.stAjusteAprovacaoSaida == 1) || lstAtividades.length == 0 || !getAtividadeParaAprovar"
          (click)="toggleModalAprovacao()"
        >

          Enviar Atividades para Validação
        </button> -->
      </div>
    </div>
    <div class="row_quantidade_tempo_registro">
      @if(lstAtividades.length > 0) {
      <p>
        <b
          >Total tempo de atividades registradas:
          {{ totalHorasAtividades | date : "HH:mm" }}</b
        >
      </p>
      }
    </div>

    <app-aviso-atividade-jornada />

    @if(isCheckoutFlow) {
    <div class="checkout-intermediario">
      @if(lstAtividades.length === 0) {
      <p class="checkout-intermediario__empty">
        Você ainda não registrou atividades. Poderá lançá-las durante o próximo check-in.
      </p>
      }

      <div class="checkout-intermediario__acoes">
        <button
          *ngIf="exibirBotaoAdicionarAtividade()"
          class="btn_outline"
          (click)="redirectToAddAtividade()"
        >
          + Adicionar Atividade
        </button>
        <button class="btn_outline" (click)="cancelarFluxoCheckout()">Cancelar</button>
        <button
          class="btn_segundario"
          [disabled]="!this.jornadaNaoFinalizada?.dataInicio || this.jornadaNaoFinalizada?.dataFim"
          (click)="abrirModalFinalizarJornada()"
        >
          Confirmar Saída
        </button>
      </div>
    </div>
    }

    <div class="conteudo_legenda_grid">
      <h4>Legenda</h4>
      <div class="legenda_grid">
        <div class="legenda_item">
          <i class="fa-solid fa-circle-plus" aria-hidden="true"></i>
          <p>Adicionar Registro</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-eye" aria-hidden="true"></i>
          <p>Visualizar</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-edit" aria-hidden="true"></i>
          <p> Edição</p>
        </div>
        <div class="legenda_item">
          <i class="fa fa-trash" aria-hidden="true"></i>
          <p>Excluir</p>
        </div>
      </div>
    </div>

    <app-tabulator-table
      [tableData]="lstAtividades"
      [columnNames]="colunasGrid"
      [tableTitle]="'teste'"
      [tipoRelatorio]="2"
      [orientacaoPortrait]="false"
    />
  </div>
</section>

<app-modal class="modal-overlay" *ngIf="showModal">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Deseja excluir o Registro da Atividade?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalExcluirAtividade()">
        ✖
      </button>
    </div>

    <br />

    <!-- Corpo do Modal -->

    <!-- Footer do Modal -->
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalExcluirAtividade()">
        Não
      </button>
      <button class="btn_primeiro" (click)="OnExcluirAtividade()">Sim</button>
    </div>
  </div>
</app-modal>

<app-modal class="modal-overlay" *ngIf="showModalAprovacao">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Enviar Atividades para Avaliação?</h2>
      </div>
      <button class="btn-fechar-modal" (click)="toggleModalAprovacao()">
        ✖
      </button>
    </div>

    <br />
    <!-- @if(tempoRegistroMaiorQue30min()){
    <form [formGroup]="formJustificarTempoRegistro" class="modal-body">
      <div class="grup_input">
        <label>Justifique o tempo de registro acima de 30 minutos:</label>
        <textarea
          class="input-textarea"
          formControlName="justificativa"
          rows="3"
          placeholder="Descreva a justificativa da avaliação"
          aria-label="Descreva a justificativa da avaliação"
        ></textarea>
        <p>
          Quantidade de caracteres atual:
          {{ formJustificarTempoRegistro.get("justificativa")?.value?.length }}
        </p>
        <div
          *ngIf="
            formJustificarTempoRegistro.get('justificativa')?.errors &&
            formJustificarTempoRegistro.get('justificativa')?.touched
          "
          class="alert"
        >
          <div
            *ngIf="
              formJustificarTempoRegistro.get('justificativa')?.errors
                ?.required
            "
          >
            * É obrigatório preencher esse campo
          </div>
          <div
            *ngIf="
              formJustificarTempoRegistro.get('justificativa')?.errors
                ?.minlength
            "
          >
            * É obrigatório no mínimo digitar 150 caracteres.
          </div>
          <div
            *ngIf="
              formJustificarTempoRegistro.get('justificativa')?.errors
                ?.maxlength
            "
          >
            * Máximo de caracteres é 500.
          </div>
        </div>
      </div>
    </form>

    } -->
    <br />
    <!-- Corpo do Modal -->

    <!-- Footer do Modal -->
    <div class="modal-footer">
      <button class="btn_segundario" (click)="toggleModalAprovacao()">
        Não
      </button>
      <button class="btn_primeiro" (click)="OnEnviarAtividade()">Sim</button>
    </div>
  </div>
</app-modal>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
